module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0cc8cff23987f4d8d8813ec795205b6c.png";